exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper-frame[data-v-5670f7ec]{width:100%;padding:25px;margin-bottom:15px\n}\n.form-wrapper-frame .control-loader[data-v-5670f7ec]{margin-top:25px\n}\n.form-wrapper-frame .additional-settings[data-v-5670f7ec]{padding-top:20px\n}\n.form-wrapper-frame .video-list[data-v-5670f7ec]{margin:20px 0\n}\n.form-wrapper-frame .md-button[data-v-5670f7ec]{background-color:#4ea9dd;color:rgba(255,255,255,.87)\n}\n.md-table-pagination[data-v-5670f7ec]{display:flex;flex-direction:row;align-items:center;justify-content:center;margin:10px auto;width:80%\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-5670f7ec","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/distribution/form-components/ContentForm.vue
// module id = 131
// module chunks = 0